import { CARD_CONFIG } from '../Card.constants';

const REGEX_AMERICAN_EX = /^3[47]/;

export const getCardConfig = (card) => (REGEX_AMERICAN_EX.test(card) ? CARD_CONFIG.AMERICAN_EX : CARD_CONFIG.DEFAULT);
